import React, { useState, useEffect, useContext, useRef } from "react";
import quizThumb from '../../assets/images/quiz-default.jpg';
import Footer from "../../components/footer/Footer";
import SideMenu from "../student/SideMenu";
// import Sidebar from "../../components/dashboard/sidebar";
import Header from "../../components/dashboard/header";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import tmdbApi from "../../api/tmdbApi";
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import parse from "react-html-parser";
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { contentContext } from "../../context/contentContext";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import Loader from "../../components/loader";
import OpenSeadragon from "openseadragon";
import deepZoom from "../../assets/images/icons/Dna-dz.svg";

const Quiz = () => {
    let { id } = useParams();
    const transformRef = useRef(null);
    const viewerRef = useRef(null);
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);
    const { state } = useLocation();
    const navigate = useNavigate();
    const [cpcQtns, setCpcQtns] = useState(null);
    const [answers, setAnswersData] = useState(null);
    const [qdisplay, setQdisplay] = useState(false);
    const [imageCloudfront, setImg] = useState(false);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [popupImage, setPopupImage] = useState(false);
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [img, setImage] = useState("");
    const [popup, setPopup] = useState(false)
    const handleClosePopup = () => setPopup(false);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [activeField, setActiveField] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isAutoSliding, setIsAutoSliding] = useState(false);
    const [index, setIndex] = useState(-1);
    const [gallery, setGallery] = useState([]);
    const [currentImage, setcurrentImage] = useState(null);
    const [nextIndex, setnextIndex] = useState(null);
    const [nextImage, setnextImage] = useState(null);
    const [prevIndex, setprevIndex] = useState(null);
    const [prevImage, setprevImage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [selected, setSelected] = useState({});
    const [successMsg, setSuccessMsg] = useState(false)
    const [handleBackPopup, setHandleBackPopup] = useState(false)
    const [viewer, setViewer] = useState(null);

    const [dziUrl, setDziUrl] = useState("");
    const [dziUrlFile, setDziUrlFile] = useState("");
    const [dzipopupImage, setDZIPopupImage] = useState(false);

    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [dragActive, setDragActive] = useState(false);
    const [loader, setLoader] = useState(false);

    const [showImagePopup, setShowImagePopup] = useState(false);
    const [popupPngImage, setPopupPngImage] = useState(null);
    const [moduleid, setModuleid] = useState(null);
    const getExtension = (filename) => {

        if (!filename) return null;
        let extType = filename.split('.').pop().toLowerCase();
        let valReturn = ".jpeg,.jpg,.png";
        if (extType === 'tiff' || extType === 'tif') {
            valReturn = ".tif,.tiff";
        }
        return valReturn
    };
    useEffect(() => {
        if (!viewerRef.current) return;

        console.log("Loading OpenSeadragon with URL:", dziUrl);
        const isDziURL = dziUrl.includes("output.dzi");
        const { width, height } = imageDimensions; // Destructure imageDimensions for clarity


        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };

        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: "Anonymous",
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });


        setViewer(osdViewer);

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);
    const rotateImage = (angle) => {
        if (viewer) {
            const newRotation = (rotation + angle) % 360;
            viewer.viewport.setRotation(newRotation);
            setRotation(newRotation);
        }
    };

    const resetZoom = () => {
        if (viewer) {
            viewer.viewport.goHome();
            viewer.viewport.setRotation(0);
            setRotation(0);
        }
    };

    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };
    useEffect(() => {
        if (gallery) {
            // console.log(gallery, index)
            const currentImage = gallery[index];
            setcurrentImage(currentImage)
            const nextIndex = (index + 1) % gallery.length;
            setnextIndex(nextIndex)
            const nextImage = gallery[nextIndex] || currentImage;
            setnextImage(nextImage)
            const prevIndex = (index + gallery.length - 1) % gallery.length;
            setprevIndex(prevIndex)
            const prevImage = gallery[prevIndex] || currentImage;
            setprevImage(prevImage)
        }

    }, [index]);

    useEffect(() => {
        if (currentImage) {
            const img = new Image();
            img.src = `${imageCloudfront}${currentImage?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`;
            img.onload = () => setIsLoading(false);
        }

    }, [currentImage]);

    useEffect(() => {
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [window.site]);

    const handlePopupload = (e) => {
        setPopupLoading(true)
        console.log(dziUrl, "dz")
    }

    useEffect(() => {
        const selectedLength = Object.keys(selected).length
        if (selectedLength > 0) {
            // Add event listener for popstate to detect when the user presses the back button
            const handlePopState = (event) => {

                // Display the popup
                setHandleBackPopup(true);
                // Prevent default action of going back
                event.preventDefault();
                console.log("Browser back button pressed.");

            };

            // Initially pushState to allow popstate to fire
            window.history.pushState({}, document.title, window.location.href);

            // Add popstate listener
            window.addEventListener("popstate", handlePopState);

            return () => {
                // Cleanup event listener when component unmounts
                window.removeEventListener("popstate", handlePopState);
            };
        }

    }, [selected]);

    useEffect(() => {
        // This function will handle the beforeunload event
        const handleBeforeUnload = (event) => {
            // Prevent the default browser prompt (e.g., "Changes you made may not be saved")
            event.preventDefault();
            // For most browsers to show a confirmation dialog
            event.returnValue = '';  // This triggers the native browser confirmation dialog (which we want to avoid)

            // Show custom popup instead of native browser dialog
            //   setHandleBackPopup(true);
        };

        // Add the event listener for beforeunload (when user attempts to reload/close the page)
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Cleanup on component unmount
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    const GetAnswersInfo = async () => {
        try {
            const response = await tmdbApi.answerInfo();
            setAnswersData(response?.result?.answerData);
        } catch {
            console.log("error");
        }
    };

    const [cancel, setCancel] = useState(false)
    const onCancel = () => {
        navigate("/cpc");
    };




    const getCaseInfo = async (caseid, moduleid) => {
        const response = await tmdbApi.cpcCaseModuleInfo(caseid, moduleid);
        let qtns = []
        if (response?.result?.questionData?.length > 0) {
            qtns = response?.result?.questionData.map(qtn => {
                qtn['answers'] = [
                    { id: 1, selected: {}, percent: 0 },
                    { id: 2, selected: {}, percent: 0 },
                    { id: 3, selected: {}, percent: 0 },
                    { id: 4, selected: {}, percent: 0 }
                ]
                return qtn;
            })
        }
        return qtns
    }


    // const handleSelectChange = (inputValue, Index) => {
    //     setActiveField(Index)
    //     if (inputValue != "") {
    //         const results = answersdata.filter(option =>
    //             option.answer.toLowerCase().includes(inputValue.toLowerCase())
    //         );
    //         console.log('results', results)
    //         setFilteredOptions(results);
    //     } else {
    //         setFilteredOptions([]);
    //     }
    // };


    const [filteredOptionsMap, setFilteredOptionsMap] = useState({});

    const handleSelectChange = (qIndex, selectedOption, aIndex) => {

        setActiveField(aIndex);
        setSelected(prev => ({
            ...prev,
            [`${qIndex}_${aIndex}`]: selectedOption
        }));

        let rmpQtns = [...cpcQtns]
        rmpQtns[qIndex].answers[aIndex].selected = selectedOption;
        if (!selectedOption) {

            rmpQtns[qIndex].answers[aIndex].percent = 0;


        } else {
            let ansTmp = rmpQtns[qIndex].answers.filter(ans => ans.percent === 0)

            if (ansTmp.length === 4) {
                rmpQtns[qIndex].answers[aIndex].percent = 100;

            }
        }
        setCpcQtns(rmpQtns)
        // console.log("rmpQtnsssssssssssssssssssssss",rmpQtns)

        setError(prev =>
            prev.filter(err => !err.includes(`Case ${qIndex + 1}`))
        );
    };

    const handleInputChange = (inputValue, qIndex, aIndex) => {

        setActiveField(aIndex);
        if (inputValue !== "") {
            const results = answers.filter(option =>
                option.answer.toLowerCase().includes(inputValue.toLowerCase())
            );
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${qIndex}_${aIndex}`]: results
            }));
        } else {
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${qIndex}_${aIndex}`]: []
            }));
        }
    };
    //  const handleInputChange = (inputValue, Index) => {

    //         // const tmpQttns = [...cpcQtns];
    //         // tmpQttns[qtnId].answers[index].selected = value;
    //         // setCpcQtns(tmpQttns);

    //          setActiveField(Index)
    //         if (inputValue != "") {
    //             const results = answersdata.filter(option =>
    //                 option.answer.toLowerCase().includes(inputValue.toLowerCase())
    //             );
    //             console.log('results', results)
    //             setFilteredOptions(results);
    //         } else {
    //             setFilteredOptions([]);
    //         }
    //     };


    // const handlePercentChange = (qtnId, index, value) => {
    //     const tmpQttns = [...cpcQtns];
    //     tmpQttns[qtnId].answers[index].percent = value;
    //     setCpcQtns(tmpQttns);
    // };
    const [caseId, setCaseId] = useState(null);

    const getCpcInfoById = async (id) => {

        let response = id ? await tmdbApi.cpcInfoById(id) : await tmdbApi.cpcInfo("ACTIVE");
        if (typeof response?.result === 'string') {
            alert("no active cpc")
        }
        if (response?.result?.length > 0) {
            setCaseId(response?.result[0]?.cases)
        }
        if (response?.result?.length > 0 && response?.result[0]?.moduleid) {
            setModuleid(response?.result[0]?.moduleid)
        }
    }
    // console.log('module id',moduleid)
    useEffect(() => {
        // if (state?.caseid) {
        //     localStorage.setItem("quzcaseid", JSON.stringify(state?.caseid))
        //     localStorage.setItem("quzcpcid", state?.cpcid)
        // }
        getCpcInfoById(id)

    }, [])


    const fetchData = async (caseId, moduleid) => {
        setLoader(true);  // Start loader

        try {
            if (caseId?.length > 0) {
                const casid = caseId.map(item => item.caseid);
                const tmpData = await getCaseInfo(casid, moduleid);

                setCpcQtns(tmpData?.filter(Boolean) || []);
            }
        }
        catch (error) {
            console.error("Error fetching case info:", error);
        }
        finally {
            setQdisplay(true);
            setLoader(false);  // Stop loader
        }
    };

    useEffect(() => {
        if (caseId && moduleid) {
            fetchData(caseId, moduleid);
            GetAnswersInfo()
        }

    }, [caseId, moduleid]);


    const customComponents = {
        DropdownIndicator: () => null, // Remove the dropdown indicator
        IndicatorSeparator: () => null, // Optionally remove the separator
    };


    const handlePercentChange = (qIndex, aIndex, value) => {
        value = Number(value)
        let rmpQtns = [...cpcQtns]
        if (value === '') {
            value = 0;
        }
        rmpQtns[qIndex].answers[aIndex].percent = parseInt(value || 0)
        setCpcQtns(rmpQtns)

    }

    // const handlePercentChange = (qIndex, aIndex, value) => {

    //     let newValue = parseInt(value, 10);
    //     if (isNaN(newValue)) newValue = 0;
    //     newValue = Math.max(0, Math.min(newValue, 100)); // Clamp between 0 and 100

    //     const updatedQuestions = [...cpcQtns];
    //     const answers = [...updatedQuestions[qIndex].answers];

    //     // Set the changed value
    //     answers[aIndex].percent = newValue;

    //     const remainingTotal = 100 - newValue;

    //     // Filter to only other answers that have a non-empty `selected`
    //     const otherIndexes = answers
    //         .map((ans, idx) => ({ idx, selected: ans.selected }))
    //         .filter(({ idx, selected }) => idx !== aIndex && selected?.value?.trim() !== "")
    //         .map(({ idx }) => idx);

    //     const originalOtherPercents = otherIndexes.map(i => answers[i].percent);
    //     const originalTotal = originalOtherPercents.reduce((sum, val) => sum + val, 0);

    //     if (originalTotal > 0) {
    //         let redistributed = 0;
    //         otherIndexes.forEach((idx, i) => {
    //             let newPercent = Math.floor((answers[idx].percent / originalTotal) * remainingTotal);
    //             answers[idx].percent = newPercent;
    //             redistributed += newPercent;
    //         });

    //         const diff = remainingTotal - redistributed;
    //         if (diff !== 0 && otherIndexes.length > 0) {
    //             answers[otherIndexes[0]].percent += diff;
    //         }
    //     } else {
    //         // Distribute remaining evenly if no original percent values
    //         const count = otherIndexes.length;
    //         if (count > 0) {
    //             const evenSplit = Math.floor(remainingTotal / count);
    //             const remainder = remainingTotal % count;

    //             otherIndexes.forEach((idx, i) => {
    //                 answers[idx].percent = evenSplit + (i === 0 ? remainder : 0);
    //             });
    //         }
    //     }

    //     updatedQuestions[qIndex].answers = answers;
    //     setCpcQtns(updatedQuestions);
    // };



    const onReset = (e) => {
        window.scrollTo(0, 0);
        e.preventDefault()
        setresetpopup(true)
        // setSelected({})
    };

    const ErrorList = ({ errors }) => {
        if (!errors || errors.length === 0) {
            return null; // No errors to display
        }

        return (
            <div style={{ color: 'red' }}>
                <ul style={{ display: "block" }}>
                    {errors.map((error, index) => (
                        <li key={index}>{error}</li>
                    ))}
                </ul>
            </div>
        );
    };

    const [error, setError] = useState([])


    // const handleSubmit = async (e) => {
    //     // let cpcQtnsTmp = cpcQtns.filter(qtn => {
    //     //     return qtn.answers.filter(ans => ans.selected && ans.selected.trim() !== '').length > 0;
    //     // });
    //     const validated = cpcQtns.map(qtn => {
    //         const selectedAnswers = qtn.answers.filter(ans =>
    //             Object.keys(ans.selected || {}).length > 0
    //         );

    //         const totalPercent = selectedAnswers.reduce(
    //             (sum, ans) => sum + (parseFloat(ans.percent) || 0),
    //             0
    //         );

    //         return {
    //             caseid: qtn.caseid,
    //             answers: selectedAnswers,
    //             casetitle: qtn.casetitle,
    //             selectedCount: selectedAnswers.length,
    //             totalPercent,
    //             valid: selectedAnswers.length > 0 && totalPercent === 100
    //         };
    //     });

    //     let isValid = validated.filter(val => val.totalPercent === 100)
    //     if (isValid.length === cpcQtns.length) {
    //         setError([])
    //         let res = await tmdbApi.addCpcParticipantAnswers(validated);
    //         if (res.result) {

    //         }

    //     } else {
    //         let err = []
    //         if (isValid.length == 0) {
    //             err.push("Please select atleast one option for question")
    //         }
    //         console.log(isValid,"isValid")

    //         setError(err)

    //     }
    // }

    const handleSubmit = async (e) => {
        const validated = cpcQtns.map((qtn, index) => {
            const selectedAnswers = qtn.answers.filter(ans =>
                Object.keys(ans.selected || {}).length > 0
            );

            const totalPercent = selectedAnswers.reduce(
                (sum, ans) => sum + (parseFloat(ans.percent) || 0),
                0
            );

            const valid = selectedAnswers.length > 0 && totalPercent === 100;

            return {
                caseid: qtn.caseid,
                answers: selectedAnswers,
                diagnosis: qtn.diagnosis,
                explanation: qtn.explanation,
                clinicalhistory: qtn.clinicalhistory,
                title: 'Case ' + (index + 1),
                selectedCount: selectedAnswers.length,
                totalPercent,
                valid,
                index
            };
        });
        // console.log("validateeeeeeeeeeeeeeeeeeeeeeeeeeeee",validated)
        const invalidQuestions = validated.filter(val => !val.valid);
        console.log(cpcQtns)
        if (invalidQuestions.length === 0) {
            setError([]);

            let payload = {
                "cpcid": id,
                "userid": localStorage.getItem("userId"),
                "cases": []
            };
            validated.forEach((caseData) => {
                let answers = [];
                caseData.answers.forEach(ans => {
                    let ansObj = {
                        "answerid": ans?.selected?.value,
                        "answer": ans?.selected?.label,
                        "weightage": ans.percent
                    }
                    answers.push(ansObj)
                });
                let obj = {
                    "caseid": caseData.caseid,
                    "answers": answers,
                    "diagnosis": caseData.diagnosis,
                    "explanation": caseData.explanation,
                    "clinicalhistory": caseData.clinicalhistory,

                }
                payload.cases.push(obj)
                // console.log("obj--->",obj)
            })


            const res = await tmdbApi.addCpcParticipantAnswers(payload);

            if (res.result?.toLowerCase() === "cpc participant answer added successfully") {
                // success logic here
                setSuccessMsg(true)
            }
        } else {
            const errMessages = invalidQuestions.map(q => {
                if (q.selectedCount === 0) {
                    return `Question "${q.title}" requires at least one selected option.`;
                } else if (q.totalPercent !== 100) {
                    return `Total percentage for question "${q.title}" must equal 100%. Currently: ${q.totalPercent}%.`;
                }
                return '';
            });

            setError(errMessages);
        }
    };

    const refresh = () => {
        navigate("/cpc")
    }

    const handlePngPopupImage = (imageUrl) => {
        setShowImagePopup(true)
        setPopupPngImage(imageUrl)
    }


    const onResetConfirm = async (e) => {
        setresetpopup(false)
        setSelected({})
        fetchData();

    }
    const onResetReject = (e) => {
        setresetpopup(false)
        setError([])
    }

    return (
        <div id="layout-wrapper">
            <Header />
            <SideMenu />

            <div className="main-content user-management quiz-page" id="main-content">
                <div className="page-content" id="page-content">
                    <div className="container-fluid" id="container-fluid">
                        <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                            <div className="col-lg-12">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <h4 className="mb-2 card-title" id="breadcrumb-title">
                                            CPC Quiz
                                        </h4>

                                    </div>
                                    <div className="create-quiz-btn" onClick={() => onCancel()}>
                                        Back
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row table-data">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body cpc-management">

                                        <div className="wrapper client_wrapper mt-3 pt-3">
                                            <div className="wrapper quiz_page">
                                                {/* <div className="form_block">
                                <div className="quiz_info">
                                    <div className="img"></div>
                                    <div className="left"></div>
                                    <div className="create-quiz-btn" onClick={() => setCancel(true)}>
                                        Back to Home
                                    </div>
                                </div>
                            </div> */}


                                                <div className="question_block quiz-page">

                                                    {!qdisplay &&

                                                        <div className="empty-state-body empty-record"  >
                                                            <div className="empty-state__message">
                                                                <p className="form-check font-size-16">Loading...</p>
                                                            </div>
                                                        </div>

                                                    }
                                                    {loader ? <Loader /> :
                                                        qdisplay && cpcQtns && (
                                                            <div className="mb-4">
                                                                {cpcQtns.map((item, qIndex) => (
                                                                    <div key={qIndex} className="mb-4 case-block">
                                                                        {/* <h3>{item?.casetitle}</h3>
                                                    <p dangerouslySetInnerHTML={{ __html: item?.description }} />
                                                    <div className={item?.files?.length > 0 ? "quiz_info content" : "quiz_info no-image content"}>
                                                        <div className="img_block">
                                                            {item?.files?.map((file, fileIndex) => (
                                                                <div
                                                                    key={fileIndex}
                                                                    className="img"
                                                                    onClick={(e) => {
                                                                        setPopupOpen(true);
                                                                        setPopupImage(imageCloudfront + file?.filepath.replace(/ /g, "%20"));
                                                                        handlePopupload(e);
                                                                    }}
                                                                >
                                                                    <span className="material-symbols-outlined img_view">zoom_out_map</span>
                                                                    <img
                                                                        src={`${imageCloudfront}${file?.filepath.replace(/ /g, "%20")}?auto=compress,format&width=125`}
                                                                        alt={`Quiz Image ${fileIndex + 1}`}
                                                                        loading="lazy"
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div> */}
                                                                        <div className=" cpcquiz-ques">
                                                                            <div className="row justify-content-between align-items-start col-lg-12">
                                                                                <div className="d-flex flex-column col-lg-7 quiz-ques-sect">
                                                                                    <h3 className="col-lg-12 quiz-title">Case {qIndex + 1}</h3>
                                                                                    <p className="col-lg-12 quiz-para" dangerouslySetInnerHTML={{ __html: item?.clinicalhistory }} />
                                                                                    <div>
                                                                                        {
                                                                                            item?.answers.map((ans, aIndex) => {
                                                                                                const selectedIndex = `${qIndex}_${aIndex}`;

                                                                                                // Get selected answers for the current question only (qIndex)
                                                                                                const selectedAns = Object.entries(selected)
                                                                                                    .filter(([key]) => key.startsWith(`${qIndex}_`) && key !== selectedIndex)
                                                                                                    .map(([, val]) => val?.value)
                                                                                                    .filter(Boolean); // Remove undefined/null

                                                                                                let options = filteredOptionsMap[selectedIndex]?.map((eachItem) => ({
                                                                                                    value: `${eachItem.answerid}`,
                                                                                                    label: eachItem.answer
                                                                                                })) || [];

                                                                                                // Filter out selected options only from this question
                                                                                                if (selectedAns.length > 0) {
                                                                                                    options = options.filter(opt => !selectedAns.includes(opt.value));
                                                                                                }

                                                                                                return (
                                                                                                    <div
                                                                                                        key={aIndex}
                                                                                                        style={{
                                                                                                            display: "flex",
                                                                                                            alignItems: "center",
                                                                                                            gap: "10px",
                                                                                                            marginBottom: "10px"
                                                                                                        }}
                                                                                                    >
                                                                                                        <Select
                                                                                                            className="select"
                                                                                                            isMulti={false}
                                                                                                            placeholder="Type Answer and Select"
                                                                                                            onChange={(option) => handleSelectChange(qIndex, option, aIndex)}
                                                                                                            onInputChange={(value) => handleInputChange(value, qIndex, aIndex)}
                                                                                                            options={options}
                                                                                                            isClearable
                                                                                                            value={selected[selectedIndex] || null}
                                                                                                            menuIsOpen={
                                                                                                                activeField === aIndex &&
                                                                                                                filteredOptionsMap[selectedIndex]?.length > 0
                                                                                                            }
                                                                                                            components={customComponents}
                                                                                                        />

                                                                                                        <input
                                                                                                            type="text"
                                                                                                            placeholder="%"
                                                                                                            disabled={!selected[selectedIndex]}
                                                                                                            value={ans.percent}
                                                                                                            onChange={(e) => handlePercentChange(qIndex, aIndex, e.target.value)}
                                                                                                            style={{ width: "80px", height: "34px" }}
                                                                                                        />
                                                                                                        <span>%</span>
                                                                                                    </div>
                                                                                                );
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-4 quiz-img-section">
                                                                                    {/* <h6 className="quiz-para text-dark"></h6> */}
                                                                                    <div className={item?.files?.length > 0 ? "quiz_info content" : "quiz_info no-image content"}>
                                                                                        {/* <div className="d-flex justify-content-start align-items-center flex-wrap"> */}
                                                                                        <div className="d-grid justify-content-start gap-2 align-items-center">
                                                                                            <div className="img-wrapper">
                                                                                                {item?.files && item?.files.length > 0 && <p className="mt-2">Histological Photos</p>}

                                                                                                <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper">
                                                                                                    {item?.files?.map((file, fileIndex) => (
                                                                                                        file.dzistatus == "COMPLETED" &&
                                                                                                        <div
                                                                                                            key={fileIndex}

                                                                                                            className={`img me-2 ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`}
                                                                                                            style={{ width: 'auto' }}
                                                                                                            onClick={(e) => {

                                                                                                                let filepath = file?.sourcepath || file?.filepath || "";
                                                                                                                let imagePath = `${imageCloudfront}${filepath && filepath?.replace(/ /g, "%20")}?auto=compress,format`

                                                                                                                //handlePopupImage(imagePath)
                                                                                                                setPopupOpen(true);
                                                                                                                setImageDimensions({ width: file.width, height: file.height });

                                                                                                                let path = file.dziUrl || "";
                                                                                                                if (path.startsWith("/")) path = path.slice(1);
                                                                                                                let isDziURL = path.includes("output.dzi");
                                                                                                                if (isDziURL) {
                                                                                                                    path = `${path}_files/`;
                                                                                                                    setDziUrl(imageCloudfront + path);
                                                                                                                } else {
                                                                                                                    setDziUrl(imagePath);
                                                                                                                }

                                                                                                                setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)
                                                                                                                setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                                                handlePopupload(e);

                                                                                                            }}
                                                                                                        >
                                                                                                            <span className="material-symbols-outlined img_view">zoom_out_map</span>

                                                                                                            {/* <img src={file?.thumbnailUrl ? `${imageCloudfront?.replace(/\/$/, "")}${file?.thumbnailUrl.replace(/ /g, '%20')}?auto=compress,format&width=150` : deepZoom} alt={file?.originalFilename} /></span> */}

                                                                                                            {/* <img
                                                                                                        src={`${imageCloudfront}${file?.filepath.replace(/ /g, "%20")}?auto=compress,format&width=125`}
                                                                                                        alt={`Quiz Image ${fileIndex + 1}`}
                                                                                                        loading="lazy"
                                                                                                    />  */}

                                                                                                            <span className="default-img">

                                                                                                                <img src={file?.thumbnailUrl ? imageCloudfront?.replace(/\/$/, "") + file?.thumbnailUrl + "?auto=compress,format&width=150" : (

                                                                                                                    file?.sourcepath ? `${imageCloudfront}${file?.sourcepath && file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format` : deepZoom
                                                                                                                )} alt={file?.originalFilename} />

                                                                                                            </span>

                                                                                                        </div>


                                                                                                    ))}
                                                                                                </div>
                                                                                            </div>

                                                                                            <div className="img-wrapper">
                                                                                                {item?.historyfiles && item?.historyfiles.length > 0 &&
                                                                                                    <p>Clinical History Photos</p>}

                                                                                                <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper">
                                                                                                    {item?.historyfiles && item?.historyfiles.length > 0 && item?.historyfiles?.map((file, key) => {

                                                                                                        let imagePath = `${imageCloudfront}${file?.sourcepath && file?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`

                                                                                                        return (

                                                                                                            <div
                                                                                                                key={key}
                                                                                                                className={`img me-2 ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`}
                                                                                                                style={{ width: 'auto' }}
                                                                                                                onClick={(e) => handlePngPopupImage(imagePath)}
                                                                                                            >
                                                                                                                <span className="material-symbols-outlined img_view img-zoom">zoom_out_map</span>
                                                                                                                <img
                                                                                                                    src={`${imageCloudfront}${file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format&width=150`}
                                                                                                                    alt={`Image ${key + 1}`}
                                                                                                                    loading="lazy"
                                                                                                                />
                                                                                                            </div>


                                                                                                        )
                                                                                                    })}


                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                            <div className="cpcquiz-line">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )
                                                    }
                                                    {error.length > 0 && <ErrorList errors={error} />}
                                                    {/* <div className="btns"> */}
                                                    {/* <button type="submit" disabled={selected && Object.keys(selected).length > 0 ? false : true} className=" vs_btn mr-10" onClick={(e) => handleSubmit(e)}>Submit</button>

                          <button type="submit" disabled={selected && Object.keys(selected).length > 0 ? false : true} className="border_btn mr-10" onClick={(e) => onReset(e)}>Reset</button> */}
                                                    {/* 
                                    <button type="submit" className=" vs_btn mr-10" onClick={(e) => handleSubmit(e)}>Submit</button>

                                    <button type="submit" className="border_btn mr-10" onClick={(e) => onReset(e)}>Reset</button>

                                    <button type="submit" className="border_btn mr-10" onClick={(e) => onCancel(e)}>Cancel</button>
                                </div>
                            </div> */}
                                                    <div className="btns quiz-form-btns">
                                                        {/* <button type="submit" disabled={selected && Object.keys(selected).length > 0 ? false : true} className=" vs_btn mr-10" onClick={(e) => handleSubmit(e)}>Submit</button>
                          <button type="submit" disabled={selected && Object.keys(selected).length > 0 ? false : true} className="border_btn mr-10" onClick={(e) => onReset(e)}>Reset</button> */}
                                                        <button type="submit" className="create-quiz-btn border-0 mr-10" onClick={(e) => handleSubmit(e)}>Submit</button>
                                                        <button type="submit" className="fw-normal outline_btn reset-quiz-btn mr-10" onClick={(e) => onReset(e)}>Reset</button>
                                                        <button type="submit" className="fw-normal outline_btn reset-quiz-btn mr-10" onClick={(e) => setCancel(true)}>Cancel</button>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

            {isPopupOpen && !dziUrl && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                    onClick={() => setPopupOpen(false)}
                >
                    <div className="popup_wrp"
                        style={{
                            position: "relative",
                            background: "white",
                            padding: "10px",
                            borderRadius: "10px",
                            maxWidth: "90vw",
                            maxHeight: "90vh",

                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "white",
                                color: "#000",
                                border: "none",

                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                            onClick={() => setPopupOpen(false)}
                        >
                            <span className="material-symbols-outlined">
                                close
                            </span>
                        </button>

                        {/* Zoomable Image */}
                        <TransformWrapper ref={transformRef} initialScale={1}>
                            <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                <button onClick={() => transformRef.current.zoomIn()} className="btnzoom" ><span className="material-symbols-outlined"> add </span></button>
                                <button onClick={() => transformRef.current.zoomOut()} className="btnzoom"><span className="material-symbols-outlined"> remove </span></button>
                                <button onClick={() => transformRef.current.resetTransform()} className="btnzoom"><span className="material-symbols-outlined"> refresh </span></button>
                            </div>

                            <TransformComponent>


                                {isPopupLoading && <div style={{ width: "400px", height: "400px" }}><Loader /> </div>}

                                <LazyLoadImage
                                    src={popupImage + `? auto = compress, format`}
                                    effect="blur"
                                    onLoad={() => setPopupLoading(false)}
                                    style={{ width: "100%", borderRadius: "10px" }}
                                />

                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            )}

            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                <div className="deep_zoom">
                    <div
                        style={{
                            position: "fixed",
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                            borderRadius: "18px"
                        }}
                    >
                        <div style={{
                            width: "98vw",
                            height: "98vh",
                            position: "relative",
                            backgroundColor: "black",
                            overflow: "hidden"
                        }}>
                            {/* Deep Zoom Header */}
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px 20px",
                                backgroundColor: "#f8f9fa",
                                borderBottom: "1px solid #dee2e6"
                            }}>
                                <h3 style={{ fontSize: "18px" }}>
                                    {/* {dziUrlFile ? dziUrlFile : ''} */}
                                </h3>
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    {/* <button
                                    className="create-quiz-btn border-0"
                                    onClick={resetZoom}
                                >
                                    Reset View
                                </button>
                                <button
                                    onClick={() => rotateImage(90)}
                                    className="create-quiz-btn border-0"

                                >
                                    Rotate 90°
                                </button> */}
                                    <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        style={{
                                            border: "none",
                                            fontWeight: "800",
                                        }}
                                    >
                                        <span className="material-symbols-outlined">close</span>
                                    </button>
                                </div>
                            </div>

                            {/* Deep Zoom Viewer Container */}
                            <div style={{
                                height: "calc(95vh - 80px)",
                                width: "100%",
                                position: "relative"
                            }}>
                                <div
                                    id="openseadragon-viewer"
                                    ref={viewerRef}
                                    style={{
                                        height: "100%",
                                        width: "100%"
                                    }}
                                />

                                {/* Instructions */}
                                {/* <div style={{
                                    position: "absolute",
                                    bottom: "20px",
                                    left: "20px",
                                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                                    color: "white",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    fontSize: "12px"
                                }}>
                                    <p style={{ margin: "2px 0" }}>• Zoom with mouse wheel or pinch gesture</p>
                                    <p style={{ margin: "2px 0" }}>• Pan by clicking and dragging</p>
                                    <p style={{ margin: "2px 0" }}>• Use the navigator in the bottom-right for orientation</p>
                                    <p style={{ margin: "2px 0" }}>• Use toolbar buttons to rotate or reset view</p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )}


            <SweetAlert
                show={successMsg}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title="Thank you for your participation. The results will be announced soon."
                onConfirm={e => refresh()}
                id="error-alert"
            ></SweetAlert>


            <SweetAlert
                show={cancel}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure want to close?"
                focusCancelBtn
                onConfirm={e => onCancel()}
                onCancel={e => setCancel(false)}
            >
            </SweetAlert>

            <SweetAlert show={resetpopup}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure to reset the Quiz?"
                focusCancelBtn
                onConfirm={e => onResetConfirm()}
                onCancel={e => onResetReject()}
            ></SweetAlert>


            {/* {dziUrl && (
                <section className="viewer-section">
                    <div className="viewer-header">
                        <h2>Deep Zoom Viewer</h2>
                        <div className="viewer-controls">
                            <button className="control-button" onClick={() => window.location.reload()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 2v6h-6"></path>
                                    <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                                    <path d="M3 22v-6h6"></path>
                                    <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                                </svg>
                                <span>Reset</span>
                            </button>
                        </div>
                    </div>

                    <div className="viewer-container">
                        <div id="openseadragon-viewer" ref={viewerRef}></div>
                        <div className="viewer-instructions">
                            <p>• Zoom with mouse wheel or pinch gesture</p>
                            <p>• Pan by clicking and dragging</p>
                            <p>• Use the navigator in the bottom-right for orientation</p>
                        </div>
                    </div>
                </section>
            )} */}


            {showImagePopup && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.8)",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => setShowImagePopup(false)}
                >
                    <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                        <img src={popupPngImage} className="modal-img" />
                        <button
                            onClick={() => setShowImagePopup(false)}
                            className="create-quiz-btn border-0"
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                cursor: "pointer",
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Quiz;
